export default __webpack_public_path__ + "static/media/shipment.4a09ce43.svg";